import React, { useRef } from 'react';
import { observer } from 'mobx-react';
import { AlignmentCopyVM, IAlignmentCopyProps } from './AlignmentCopyVM';
import { Modal, ModalHeader, ModalFooter, ModalBody, Input, Label } from 'reactstrap';
import stores from 'cd-eft/models/Stores';

const alignmentStore = stores.AppStore.alignmentDesignStore;
const AlignmentCopyComponent = (props: IAlignmentCopyProps) => {
  const vm = useRef(new AlignmentCopyVM(props)).current;

  return (
    <Modal
      className="eft-action-modal"
      isOpen={alignmentStore.alignmentCopyModalOpen}
      toggle={vm.togglePopup}
      centered={true}
      size="md"
    >
      <ModalHeader toggle={vm.togglePopup}>
        <strong>
          Copy Alignment:
          <br /> {vm.initialName}
        </strong>
      </ModalHeader>
      <ModalBody>
        <div className="mt-4">
          <Label className="usa-label notes-label" for="name">
            Alignment Name
          </Label>
          <Input
            name="name"
            aria-label="element-name"
            data-testid="element-name"
            placeholder="Type Name Here"
            value={vm.copy.name}
            onChange={vm.handleChange}
          />
          <span className="usa-error-message" id="client--message" role="alert">
            {vm.formValidation.formErrors.name}
          </span>
        </div>
        <div className="grid-row">
          <div className="grid-col flex-1 mr-3">
            <Label className="usa-label notes-label" for="offset">
              Off-set
            </Label>
            <Input
              name="offset"
              aria-label="element-offset"
              data-testid="element-offset"
              value={vm.copy.offset}
              onChange={vm.handleChange}
            />
          </div>

          <div className="grid-col flex-1">
            <Label className="usa-label notes-label" for="number">
              Number of Copies
            </Label>
            <Input
              name="number"
              aria-label="element-number"
              data-testid="element-number"
              placeholder="##"
              value={vm.copy.number}
              onChange={vm.handleChange}
            />
          </div>
        </div>
      </ModalBody>

      <ModalFooter className="m-3">
        <button className="usa-button usa-button--outline" onClick={vm.togglePopup}>
          Close
        </button>
        <button className="usa-button" onClick={vm.submitCopy}>
          Copy
        </button>
      </ModalFooter>
    </Modal>
  );
};

export const AlignmentCopy = observer(AlignmentCopyComponent);
